<template>
  <div class="public-notice-layout" v-if="homeMessage">
    <img src="@/assets/images/home/public-notice.png" alt="公告" class="public-notice" />
    <img src="@/assets/images/home/public-notice-noise.png" alt="公告" class="noise" />
    <span>{{ homeMessage }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'PublicNotice',
  computed: {
    ...mapState({
      homeMessage: ({ message }) => message.homeMessage
    })
  },
  async mounted() {
    try {
      this.$store.commit('message/SET_HOME_MESSAGE_TIP', '')
      await this.$store.dispatch('message/homeMessageTips', { tipCode: 'NEW_YEAR_TIP' })
      await this.$store.dispatch('message/homeMessageTips', { tipCode: 'NET_GO_ONLINE_TIP' })
    } catch (error) {
      console.log(error)
    }
  }
}
</script>

<style lang="scss" scoped>
.public-notice-layout {
  height: 56px;
  background: rgba(0, 0, 0, 0.15);
  transform: translateY(-56px);
  font-size: 14px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 9;
  .public-notice {
    width: 44px;
    height: 20px;
    margin-right: 10px;
  }
  .noise {
    width: 19px;
    height: 23px;
    margin-right: 25px;
  }
}
</style>
